import React, { Component } from "react";
import { Container } from "react-bootstrap";
import "./Careers.css";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
import axios from "axios";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const testimonialsData = [
  {
    id: 1,
    quote: "What I love about Ambrum is the balance cutting edge tech meets a deeply collaborative culture. We don’t just code solutions, we build products that matter.Ambrum is a place where voices are heard. Whether you’re an intern or a team lead, your input shapes the outcome. It’s not just work, it’s ownership.",
    name: "Tharindu Mihiran",
    position: "Tech Lead",
    image: "./assets/people/tech-lead.png"
  },
];

const images = [
  { id: 1, src: './assets/images/slider/slider1.png', alt: 'Slide 1' },
  { id: 2, src: './assets/images/slider/slider2.png', alt: 'Slide 2' },
  { id: 3, src: './assets/images/slider/slider3.png', alt: 'Slide 3' },
  { id: 4, src: './assets/images/slider/slider4.png', alt: 'Slide 4' },
]

const interviewSteps = [
  "Phone Screening",
  "First Interview",
  "Assessment",
  "Final Interview",
];

export default class Careers extends Component {
  componentDidMount() {
    const url = 'https://www.ambrumsolutions.com/api/ambrum-website/';

    window.scrollTo(0, 0);

    axios
      .get(url + 'get-all-job-details')
      .then((response) => {
        if (response.data.status && Array.isArray(response.data.data)) {
          const filteredJobs = response.data.data.filter(
            (job) => Object.keys(job).length > 0
          );
          this.setState({ jobs: filteredJobs });
        }
      })
      .catch((error) => {
        console.error("Error fetching job data:", error);
      });
  }

  constructor(props) {
    super(props);
    this.state = {
      currentTestimonialIndex: 0,
      jobs: []
    };
    this.bottomRef = React.createRef();
  }

  nextTestimonial = () => {
    this.setState(prevState => ({
      currentTestimonialIndex: prevState.currentTestimonialIndex === testimonialsData.length - 1
        ? 0
        : prevState.currentTestimonialIndex + 1
    }));
  };

  scrollToBottom = () => {
    if (this.bottomRef.current) {
      this.bottomRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  render() {
    const currentTestimonial = testimonialsData[this.state.currentTestimonialIndex];
    return (
      <div className="mt-9">
        <Container>
          <div className="text-center">
            <p className="hero-text-2 hero-text-gradient-2">
              Where Passion Meets Purpose
            </p>
            <p>
              We're looking for passionate individuals who dare to think
              differently and are ready to make their mark in technology,
              marketing, and digital revolution.
            </p>
          </div>

          {/* Innovate / Collaborate / Grow */}
          <div className="row d-flex justify-content-center g-3">
            <div className="col-4 col-sm-3 col-md-2 text-center">
              <img src="./assets/icons/world-creativity-and-innovation-day-1.gif" className="w-50 icon-gif" alt="Innovate" />
              <p className="mb-0">Innovate</p>
            </div>
            <div className="col-4 col-sm-3 col-md-2 text-center">
              <img src="./assets/icons/digital-collaboration.gif" className="w-50 icon-gif" alt="Collaborate" />
              <p className="mb-0">Collaborate</p>
            </div>
            <div className="col-4 col-sm-3 col-md-2 text-center">
              <img src="./assets/icons/growth.gif" className="w-50 icon-gif" alt="Grow" />
              <p className="mb-0">Grow</p>
            </div>
          </div>

          <div className="text-center mt-4">
            <button className="primary-btn fw-500" onClick={this.scrollToBottom}>View Openings</button>
          </div>

          <div className="row mt-5 mx-0 mx-md-4">
            {/* Testimonial */}
            <div className="col-12 col-md-6 border testimonial-box p-3">
              <p className="testimonial-quote">"{currentTestimonial.quote}"</p>
              <div className="testimonial_section">
                <div className="image_area mb-3 mb-md-0 me-md-3">
                  <img
                    className="person_image_area"
                    src={currentTestimonial.image}
                    alt={currentTestimonial.name}
                  />
                </div>

                <div className="w-100">
                  <div className="row align-items-center">
                    <div className="col-12 mb-2 mb-md-0">
                      <p className="m-0 testimonial-info">
                        {currentTestimonial.name} - <b>{currentTestimonial.position}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Slider - now matches testimonial box breakpoints so it stacks on mobile */}
            <div className="col-12 col-md-6 border slider-box p-3 mt-4 mt-md-0">
              <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={20}
                slidesPerView={1}
                loop={true}
                pagination={{ clickable: true }}
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 10 },
                  640: { slidesPerView: 1, spaceBetween: 15 },
                  1024: { slidesPerView: 1, spaceBetween: 20 }
                }}
              >
                {images.map((image) => (
                  <SwiperSlide key={image.id}>
                    <img
                      src={image.src}
                      className="w-100"
                      alt={image.alt}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* Interview Process */}
            <div className="my-5 text-center">
              <div className="hero-text-2">Interview Process</div>
              <p className="mb-4">
                We have built a simple and consistent 4 step process to evaluate
                whether Ambrum is the right fit for you and vise versa. All you
                have to do to ace an interview here at Ambrum is to bring your
                best self to the interview!
              </p>
              <div className="interview-steps-wrapper mx-auto">
                <div className="interview-steps">
                  {interviewSteps.map((step, idx) => (
                    <React.Fragment key={step}>
                      <div className="interview-step">{step}</div>
                      {idx < interviewSteps.length - 1 && (
                        <div className="interview-arrow">
                          <img
                            src="./assets/icons/right-arrow.gif"
                            className="arrow-icon"
                            alt=""
                          />
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
            <hr />

            {/* Job Listings */}
            <div className="my-5 text-center" ref={this.bottomRef}>
              <div className="hero-text-2">Careers at Ambrum</div>
              <div className="search-input-wrapper">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search"
                />
                <i className="fas fa-search search-icon"></i>
              </div>
              <div>
                {this.state.jobs.map((job) => (
                  <div
                    key={job.job_id}
                    className="row mt-4 col-12 col-md-10 bg-light m-auto job-listing-row p-3 align-items-center"
                  >
                    <div className="col-12 col-md-9 job-title text-center text-md-start">
                      {job.job_title}
                    </div>
                    <div className="col-12 col-md-3 secondary-text-color text-center text-md-end mt-2 mt-md-0">
                      <Link
                        to="/career-details"
                        state={{ jobId: job.job_id }}
                        className="text-decoration-none apply-link"
                      >
                        Apply Now &gt;
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <ContactUsFooter />
          </div>
        </Container>
        <br />
        <Footer />
      </div>
    );
  }
}
